import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { getAuthToken } from "jwt-storage-lib";

export type InstalledBuilderElement = {
    _id: string;
    name: string;
    description?: string;
    organizationId?: string | null;
    companyId?: string | null;
    iframeUrl?: string;
    isOffline?: boolean;
    isPremium?: boolean;
    width?: string;
    height?: string;
};

type GetBuilderElementsForInstalledExtensionsParams = {
    companyId: string;
};

export const builderElementsInstalledApiSlice = createApi({
    reducerPath: "builderElementsInstalledApi",
    baseQuery: fetchBaseQuery({
        baseUrl: import.meta.env.VITE_URL_HUB_API,
        prepareHeaders: async headers => {
            const token = await getAuthToken();
            if (token) {
                headers.set("Authorization", `Bearer ${token}`);
            }
            return headers;
        }
    }),
    tagTypes: ["builderElementsForInstalledExtensions"],
    endpoints: builder => ({
        getBuilderElementsForInstalledExtensions: builder.query<InstalledBuilderElement[], GetBuilderElementsForInstalledExtensionsParams>({
            query: ({ companyId }) => `code/builder-elements/installed/${companyId}`,
            providesTags: ["builderElementsForInstalledExtensions"]
        })
    })
});

export const { useGetBuilderElementsForInstalledExtensionsQuery, useLazyGetBuilderElementsForInstalledExtensionsQuery } =
    builderElementsInstalledApiSlice;
